import { render, staticRenderFns } from "./CategoryFeed.vue?vue&type=template&id=242a53fe&scoped=true&"
import script from "./CategoryFeed.vue?vue&type=script&lang=js&"
export * from "./CategoryFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a53fe",
  null
  
)

export default component.exports